<template>
  <div class="content">

    <!-- 移动端头部 -->
    <template v-if="isMobile">
      <HeaderMobile
        :loginUser="loginUser"
        :editing="editing"
        @entryEditing="entryEditing"
        @cancelEditing="cancelEditing"
        @saveEditing="saveEditing"
        @wxAuthorize="authorize"
        @createScholar="createScholar">
      </HeaderMobile>
      <!-- 移动端主题色配置 -->
      <ColorPalette :showColorPalette="true" :isMobile="isMobile" v-if="editing"></ColorPalette>

    </template>

    <!-- 电脑端头部 -->
    <template v-else>
      <Header
        :editing="editing"
        :loginUser="loginUser"
        :status="data ? Number(data.status) : 0"
        @entryEditing="entryEditing"
        @cancelEditing="cancelEditing"
        @saveEditing="saveEditing"
        @createScholar="createScholar"
        @loginScholar="loginScholar"
        @isClick="onClickShowColorPalette"
        @isMouseenter="ColorPaletteShow"
        @sortModules="sortModules">
      </Header>
    </template>

    <!-- 没有公开主页 -->
    <template v-if="!open">
      <NotPublic
        v-if="data"
        :likeCount="likeCount"
        :visiteCount="visiteCount"
        @likeAction="likeAction"
        @createScholar="createScholar"
        :profile="profile"
        :loginUser="loginUser"
        :status="parseInt(data.status)"
        :isMobile="isMobile">
      </NotPublic>
      <!-- 骨骼屏 -->
      <skeleton-index :isMobile="isMobile" v-if="notPublicSkeleton"></skeleton-index>
    </template>
    <!-- 公开主页 -->
    <template v-else>
      <ColorPalette
        v-if="!isMobile"
        ref = 'colorPaletteref'
        :showColorPalette="showColorPalette"
        :RandombackdropUrl = "backgroundUrlRondo"
        :coverType = 'coverType'
        :customCoverUrl = 'customCoverUrl'
        @isMouseenter="ColorPaletteShow"
        @isMouseleave="ColorPaletteHide"
        @getUrl="getUrl"
        @modifyRandombackdropUrl = "modifyRandombackdropUrl"
        @NotRandombackdropUrl = 'NotRandombackdropUrl'
        @modifyUpload = 'modifyUpload'
        @modifyRondom='modifyRondom'>
      </ColorPalette>
      <!-- :calss="{!isMobile ? 'back-not-mobile' : 'back-mobile'}" -->
      <el-row type="flex" justify="center"
        :style="{ 'background-image': !isMobile ? 'url('+ backgroundUrl +')' : 'url('+ backgroundUrlMobile +')'}"
        style="position: relative; background-size: cover; background-position: center center;">
        <div></div>
        <div class="row-dust" v-if="backgroundUrl"></div>
        <el-col :md="16" :xs="24">
          <section class="basic-info clearfix"
          :class="{'basic-info-mobile': isMobile}"
          :style="{'background-color': backgroundUrl&&backgroundUrl ? 'transparent' : '#fff'}"
          v-if="profile">
            <div class="pull-left">
              <template v-if="isMobile">
                <div class="img-wrap">
                  <img v-if="profile.avatar" :src="profile.avatar" alt="" class="avatar">
                </div>
              </template>
              <p class="name el-button--text forbid-hover-status"
                :style="{'color': backgroundUrl ? '#fff':''}">
                {{profile.zh_name}}<small>{{profile.en_name}}</small>
              </p>
              <p class="school-info" :style="{'color': backgroundUrl ?'#fff':''}">
                <template v-if="profile.title" :style="{'color': backgroundUrl ?'#fff':''}">
                  {{typeof profile.title == 'number' ? profile.titles_select.find(n => n.name == profile.title).value : profile.title}}
                  <template v-if="(profile.tutor && profile.tutor != '无') || profile.degree === '博士' || profile.degree == 50">/</template>
                </template>
                <template v-if="profile.tutor && profile.tutor != '无'">
                  {{profile.tutor}}
                  <template v-if="profile.degree === '博士' || profile.degree == 50">/</template>
                </template>
                <template v-if="profile.degree === '博士' || profile.degree == 50">{{typeof profile.degree == 'number' ? profile.degree_select.find(n => n.name === profile.degree).value : profile.degree}}</template>
                @{{profile.school_name}}
              </p>
              <template v-if="profile.email">
                <p class="email" v-if="!email_hide && !editing" :style="{'color': backgroundUrl ?'#fff':''}">
                  email : {{profile.email}}
                </p>
                <p :class="`email ${email_hide ? 'status-hide' : 'status-show'}`"
                  v-if="editing"
                  :style="{'color': backgroundUrl ?'#fff':''}">
                  <span class="status">
                    <span v-if="email_hide">已隐藏</span>
                    <el-tooltip class="item" effect="dark" :content="!email_hide ? '点此隐藏邮箱' : '点此显示邮箱'" placement="top-end">
                      <i :class="`iconfont icon--${email_hide ? 'hide' : 'show'}`" @click="switchHide"></i>
                    </el-tooltip>
                  </span>
                  email : {{profile.email}}
                </p>
              </template>
              <template v-else-if="!isMobile">
                <a class="email add-info el-button--text" target="_blank" :href="`${acagridOrigin}/index/user/personal_info`"  v-if="editing" :style="{'color': backgroundUrl ?'#fff':''}">绑定邮箱</a>
              </template>
              <div class="research-direction" id="research-direction">
                <template v-for="(item, index) in profile.user_tags">
                  <Tag :item="item" :key="index"
                    :class="[backgroundUrl ?'is_backgroundUrl':'']">
                  </Tag>
                </template>
                <template v-if="loginUser && loginUser.is_self == 1 && profile.user_tags.length == 0 || editing ">
                  <el-button type="primary" plain round size="mini" icon="el-icon-plus" @click="entryEditInfor()" style="vertical-align: top;">添加研究方向</el-button>
                </template>
              </div>
            </div>
            <div class="pull-right">
              <template v-if="editing">
                <el-button
                  type="text"
                  icon="iconfont icon--editor"
                  size="mini"
                  :style="{'color': backgroundUrl ?'#fff':''}"
                  @click="entryEditInfor()">
                  编辑资料
                </el-button>
              </template>
              <template v-else>
                <span class="pageviews" :style="{'color': backgroundUrl ?'#fff':''}" @click="toVisitorSection">
                  <i class="iconfont icon--show"></i>
                  {{visiteCount}}
                </span>
                <template v-if="loginUser">
                  <template v-if="loginUser.liked">
                    <el-button
                      type="text"
                      icon="iconfont icon--goods"
                      @click="toLikeSection"
                      :style="{'color': backgroundUrl ?'#fff':''}"
                      class="like">
                      {{likeCount}}
                    </el-button>
                  </template>
                  <template v-else>
                    <el-button
                      type="text"
                      icon="iconfont icon--good"
                      @click="likeAction('scroll')"
                      :style="{'color': backgroundUrl ?'#fff':''}"
                      class="like">
                      {{likeCount}}
                    </el-button>
                  </template>
                </template>
                <template v-else>
                  <el-button
                    type="text"
                    icon="iconfont icon--good"
                    @click="likeAction('scroll')"
                    :style="{'color': backgroundUrl ?'#fff':''}"
                    class="like">
                    {{likeCount}}
                  </el-button>
                </template>
              </template>
              <Social
                :socialites="socialites"
                :editing="editing"
                :name="profile.zh_name"
                :id="profile.id"
                @update="update"
                :isMobile="isMobile"
                :backgroundUrl="Boolean(backgroundUrl)">
              </Social>
            </div>
          </section>
        </el-col>
      </el-row>
      <p class="line el-button--primary forbid-hover-status"></p>
      <el-row type="flex" justify="center">
        <el-col :md="16" :xs="24">
          <div class="section-wrap" v-if="data">
            <template v-for="(item, index) in data.modules">
              <section :key="index">
                <!-- 个人简介 -->
                <template v-if="item.name === 'intro'">
                  <!-- 不可见的状态 -->
                  <HideModule
                    v-if="item.is_show == 0 && editing"
                    :item="item"
                    :index="index"
                    @updateModule="updateModule">
                  </HideModule>
                  <div class="personal-profile" v-if="item.is_show != 0">
                    <div class="head">
                      <i class="iconfont icon--intro el-button--text"></i>{{item.name_cn}}
                      <p class="operation pull-right">
                        <template v-if="editing">
                          <el-dropdown @command="handleCommand" :trigger="isMobile ? 'click' : 'hover'">
                            <span class="el-dropdown-link el-button--text">
                              <i class="iconfont icon--menu-dot"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item :command="{name: 'hideModule', index: index}">隐藏模块</el-dropdown-item>
                              <el-dropdown-item :command="{name: 'sortModule'}">模块排序</el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                        </template>
                      </p>
                    </div>
                    <div class="detail clearfix">
                      <div class="avatar-wrap">
                        <img :src="profile.avatar" class="avatar">
                        <template v-if="editing">
                          <span class="modify-masking" @click="modifyAvatar">修改头像</span>
                        </template>
                      </div>
                      <div class="text">
                        <el-input
                          type="textarea"
                          v-model="item.data"
                          :autosize="{ minRows: 7}"
                          :class="{'disabled-textarea': !editing}"
                          :placeholder="editing ? '请输入内容' : ''"
                          resize="none">
                        </el-input>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- 教育经历 -->
                <template v-else-if="item.name === 'education'">
                  <!-- 不可见的状态 -->
                  <HideModule
                    v-if="item.is_show == 0 && editing"
                    :item="item"
                    :index="index"
                    @updateModule="updateModule">
                  </HideModule>
                  <div class="educational-experience" v-if="item.is_show != 0">
                    <div class="head">
                      <i class="iconfont icon--education el-button--text"></i>{{item.name_cn}}
                      <p class="operation pull-right">
                        <template v-if="editing">
                          <el-dropdown @command="handleCommand" :trigger="isMobile ? 'click' : 'hover'">
                            <span class="el-dropdown-link el-button--text">
                              <i class="iconfont icon--menu-dot"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item :command="{name: 'hideModule', index: index}">隐藏模块</el-dropdown-item>
                              <el-dropdown-item :command="{name: 'sortModule'}">模块排序</el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                        </template>
                      </p>
                    </div>
                    <div class="detail">
                      <div class="text">
                        <el-input
                          type="textarea"
                          v-model="item.data"
                          :class="{'disabled-textarea': !editing}"
                          :placeholder="editing ? '请输入内容' : ''"
                          :autosize="{ minRows: 2}"
                          resize="none">
                        </el-input>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- 工作经验 -->
                <template v-else-if="item.name === 'career'">
                  <!-- 不可见的状态 -->
                  <HideModule
                    v-if="item.is_show == 0 && editing"
                    :item="item"
                    :index="index"
                    @updateModule="updateModule">
                  </HideModule>
                  <div class="work-experience" v-if="item.is_show != 0">
                    <div class="head">
                      <i class="iconfont icon--career el-button--text"></i>{{item.name_cn}}
                      <p class="operation pull-right">
                        <template v-if="editing">
                          <el-dropdown @command="handleCommand" :trigger="isMobile ? 'click' : 'hover'">
                            <span class="el-dropdown-link el-button--text">
                              <i class="iconfont icon--menu-dot"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item :command="{name: 'hideModule', index: index}">隐藏模块</el-dropdown-item>
                              <el-dropdown-item :command="{name: 'sortModule'}">模块排序</el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                        </template>
                      </p>
                    </div>
                    <div class="detail">
                      <div class="text">
                        <el-input
                          type="textarea"
                          v-model="item.data"
                          :class="{'disabled-textarea': !editing}"
                          :autosize="{ minRows: 2}"
                          :placeholder="editing ? '请输入内容' : ''"
                          resize="none">
                        </el-input>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- 科研论文 -->
                <template v-else-if="item.name === 'papers'">
                  <!-- 不可见的状态 -->
                  <HideModule
                    v-if="item.is_show == 0 && editing"
                    :item="item"
                    :index="index"
                    @updateModule="updateModule">
                  </HideModule>
                  <template v-else>
                    <papers
                      v-if="item.data.length > 0 && item.is_show != 0"
                      ref="papers"
                      :item="item"
                      :editing="editing"
                      :index="index"
                      @hideModule="hideModule"
                      @linkTo="linkTo"
                      @sortModules="sortModules"
                      @updateItem="updateItem"
                      @quickSort="quickSort"
                      @moreItem="moreItem"
                      @showMsg="notification"
                      :isMobile="isMobile"
                      :sortType="item.sort_type"
                      :isFirstEditing="is_first_edit">
                    </papers>
                    <!-- module 为空的状态 -->
                    <EmptyModule
                      v-if="item.data.length == 0 && item.is_show == 1 && editing"
                      :item="item"
                      :index="index"
                      @hideModule="hideModule"
                      @linkTo="linkTo"
                      :isMobile="isMobile">
                    </EmptyModule>
                  </template>
                </template>

                <!-- 主持项目 -->
                <template v-else-if="item.name === 'projects'">
                  <!-- 不可见的状态 -->
                  <HideModule
                    v-if="item.is_show == 0 && editing"
                    :item="item"
                    :index="index"
                    @updateModule="updateModule">
                  </HideModule>
                  <template v-else>
                    <projects
                      v-if="item.data.length > 0 && item.is_show != 0"
                      ref="projects"
                      :item="item"
                      :editing="editing"
                      :index="index"
                      @hideModule="hideModule"
                      @linkTo="linkTo"
                      @sortModules="sortModules"
                      @updateItem="updateItem"
                      @quickSort="quickSort"
                      @moreItem="moreItem"
                      @showMsg="notification"
                      :isMobile="isMobile"
                      :sortType="item.sort_type">
                    </projects>
                    <!-- module 为空的状态 -->
                    <EmptyModule
                      v-if="item.data.length == 0 && item.is_show == 1 && editing"
                      :item="item"
                      :index="index"
                      @hideModule="hideModule"
                      @linkTo="linkTo"
                      :isMobile="isMobile">
                    </EmptyModule>
                  </template>
                </template>

                <!-- 荣誉获奖 -->
                <template v-else-if="item.name === 'awards'">
                  <!-- 不可见的状态 -->
                  <HideModule
                    v-if="item.is_show == 0 && editing"
                    :item="item"
                    :index="index"
                    @updateModule="updateModule">
                  </HideModule>
                  <template v-else>
                    <awards
                      v-if="item.data.length > 0 && item.is_show != 0"
                      :item="item"
                      :editing="editing"
                      :index="index"
                      ref="awards"
                      @hideModule="hideModule"
                      @linkTo="linkTo"
                      @sortModules="sortModules"
                      @updateItem="updateItem"
                      @moreItem="moreItem"
                      @showMsg="notification"
                      @quickSort="quickSort"
                      :isMobile="isMobile"
                      :sortType="item.sort_type">
                    </awards>
                    <!-- module 为空的状态 -->
                    <EmptyModule
                      v-if="item.data.length == 0 && item.is_show == 1 && editing"
                      :item="item"
                      :index="index"
                      @hideModule="hideModule"
                      @linkTo="linkTo"
                      :isMobile="isMobile">
                    </EmptyModule>
                  </template>
                </template>

                <!-- 发明专利 -->
                <template v-else-if="item.name === 'patents'">
                  <!-- 不可见的状态 -->
                  <HideModule
                    v-if="item.is_show == 0 && editing"
                    :item="item"
                    :index="index"
                    @updateModule="updateModule">
                  </HideModule>
                  <template v-else>
                    <patents
                      v-if="item.data.length > 0 && item.is_show != 0"
                      ref="patents"
                      :item="item"
                      :editing="editing"
                      :index="index"
                      @hideModule="hideModule"
                      @linkTo="linkTo"
                      @sortModules="sortModules"
                      @updateItem="updateItem"
                      @moreItem="moreItem"
                      @showMsg="notification"
                      @quickSort="quickSort"
                      :isMobile="isMobile"
                      :sortType="item.sort_type">
                    </patents>
                    <!-- module 为空的状态 -->
                    <EmptyModule
                      v-if="item.data.length == 0 && item.is_show == 1 && editing"
                      :item="item"
                      :index="index"
                      @hideModule="hideModule"
                      @linkTo="linkTo"
                      :isMobile="isMobile">
                    </EmptyModule>
                  </template>
                </template>

                <!-- 学术著作 -->
                <template v-else-if="item.name === 'books'">
                  <!-- 不可见的状态 -->
                  <HideModule
                    v-if="item.is_show == 0 && editing"
                    :item="item"
                    :index="index"
                    @updateModule="updateModule">
                  </HideModule>
                  <template v-else>
                    <books
                      v-if="item.data.length > 0 && item.is_show != 0"
                      ref="books"
                      :item="item"
                      :editing="editing"
                      :index="index"
                      @hideModule="hideModule"
                      @linkTo="linkTo"
                      @sortModules="sortModules"
                      @updateItem="updateItem"
                      @moreItem="moreItem"
                      @showMsg="notification"
                      @quickSort="quickSort"
                      :isMobile="isMobile"
                      :sortType="item.sort_type">
                    </books>
                    <!-- module 为空的状态 -->
                    <EmptyModule
                      v-if="item.data.length == 0 && item.is_show == 1 && editing"
                      :item="item"
                      :index="index"
                      @hideModule="hideModule"
                      @linkTo="linkTo"
                      :isMobile="isMobile">
                    </EmptyModule>
                  </template>
                </template>
                <!-- 学术组织 -->
                <template v-else-if="item.name === 'groups'">
                  <!-- 不可见状态 -->
                  <HideModule
                    v-if="item.is_show == 0 && editing"
                    :item="item"
                    :index="index"
                    @updateModule="updateModule">
                  </HideModule>
                  <template v-else>
                    <groups
                      v-if="item.data.length > 0 && item.is_show != 0"
                      :isMobile="isMobile"
                      :index="index"
                      :item="item"
                      :editing="editing"
                      @hideModule="hideModule"
                      @sortModules="sortModules">
                    </groups>
                  </template>
                </template>
              </section>
            </template>
            <!-- 点赞 和 浏览访客模块 -->
            <Interactive
              v-if="!editing && data"
              :likeCount="likeCount"
              :visiteCount="visiteCount"
              :likes="data.likes"
              :visitLogs="data.visit_logs"
              :loginUser="loginUser"
              @likeAction="likeAction"
              :isMobile="isMobile"
              :id="parseInt(data.id)">
            </Interactive>
          </div>
        </el-col>
        <!-- 侧边导航和页面二维码 -->
        <SideTools v-if="sideToolsVisible"
          ref="sideTools"
          class="side-tools"
          :sideModules="data.modules"
          @anchorPosition="anchorPosition">
        </SideTools>
      </el-row>
      <!-- 编辑资料 -->
      <EditInfor
        v-if="dialogVisible"
        :dialogVisible="dialogVisible"
        @closeDialog="closeDialog"
        :profile="profile"
        :emailHide="email_hide"
        @updateProfile="updateProfile">
      </EditInfor>
      <!-- 编辑头像 -->
      <ModifyAvatar
        v-if="modifyDialogVisible"
        :src="profile.avatar"
        :modifyDialogVisible="modifyDialogVisible"
        @closeModifyDialog="closeModifyDialog"
        @avatarOperation="avatarOperation">
      </ModifyAvatar>
      <!-- 模块拖拽排序 -->
      <SortModules
        v-if="sortDialogVisible"
        :modules="data.modules"
        :sortDialogVisible="sortDialogVisible"
        @update="updateModules"
        @cancel="sortDialogVisible = false">
      </SortModules>

      <!-- 骨骼屏 -->
      <skeleton-index :isMobile="isMobile" :head="headSkeleton" :modules="modulesSkeleton"></skeleton-index>
      <!-- 底部广告banner -->
      <FooterAd
        v-if="profile"
        :fixed="false"
        :isMobile="isMobile"
        :loginUser="loginUser"
        :name="profile.zh_name"
        @createMyHomepage="createScholar">
      </FooterAd>
    </template>

    <!-- 移动端 操作 -->
    <template v-if="isMobile && !editing && open">
      <div class="animation-operation-div" :class="[isShow ? 'show' : '']">
        <template v-if="loginUser">
          <template v-if="parseInt(loginUser.is_self) === 1">
            <span class="left-button el-button--text" @click="shareMaskingShow">
              分享
            </span>
          </template>
          <template v-else>
            <template v-if="loginUser.liked">
              <span class="left-button el-button--text" @click="toLikeSection">
                <i class="iconfont icon--goods"></i>{{likeCount}}
              </span>
            </template>
            <template v-else>
              <span class="left-button el-button--text" @click="likeAction('scroll')">
                <i class="iconfont icon--good"></i>{{likeCount}}
              </span>
            </template>
          </template>
        </template>
        <template v-else>
          <span class="left-button el-button--text" @click="likeAction('scroll')">
            <i class="iconfont icon--good"></i>{{likeCount}}
          </span>
        </template>
        <!-- 自己 -->
        <template v-if="loginUser">
          <el-button
            v-if="parseInt(loginUser.is_self) === 1"
            type="primary"
            @click="mobileEditing"
            class="right-button">
            编辑完善
          </el-button>
          <el-button
            v-else-if="parseInt(loginUser.homepage_uid) > 0"
            type="primary"
            @click="goMyScholar(loginUser.id)"
            class="right-button">
            进入我的主页
          </el-button>
          <el-button
            v-else
            type="primary"
            @click="createScholar"
            class="right-button">
            创建我的主页
          </el-button>
        </template>
        <!-- 别人 -->
        <template v-else>
          <el-button
            type="primary"
            @click="createScholar"
            class="right-button">
            创建我的主页
          </el-button>
        </template>
      </div>
    </template>

    <template v-if="isMobile">
      <!-- 电脑编辑的弹窗 -->
      <!-- 检索后无结果弹框 -->
      <MobilePopup
        :popupVisible="popupVisible"
        :src="src"
        :title="title"
        :content="content"
        :text="text"
        @monitorEvent="copyLink"
        @closePopup="popupVisible = false">
      </MobilePopup>

      <!-- 移动端创建学术主页的弹窗 -->
      <MobileLoginDialog
        :popupVisible="chatCodeVisible"
        @closePopup="chatCodeVisible = false">
      </MobileLoginDialog>
      <!-- 跳转学术格子宣传页中间弹框 -->
      <MobileAddDialog
        class="scholar-prompt"
        title="添加学术成果"
        content="您需要使用科研神器「学术格子」管理成果"
        text="立即使用"
        :src="uploadImg"
        :popupVisible="scholarVisible"
        @closePopup="scholarVisible = false"
        @monitorEvent="lingToAcagrid">
      </MobileAddDialog>
      <!-- 点击重要程度排序弹窗 -->
      <MobileAddDialog
        class="scholar-prompt scholar-prompt-weight"
        :popupVisible="scholarWeightVisible"
        title="什么是重要度？"
        content="重要度是系统根据成果的期刊、排名、影响因子、课题类型等因素智能分析的参考值，分值从1-100，级别越高的成果重要度分值越高， 您可前往「学术格子」进行修改。"
        text="立即修改"
        :src="weightImg"
        @closePopup="scholarWeightVisible = false"
        @monitorEvent="lingToAcagrid">
      </MobileAddDialog>
      <!-- 移动端自己分享自己的弹窗 -->
      <div class="share-masking" v-if="shareMasking" @click="shareMasking = false">
        <img src="../../../assets/invite_masking.png" alt="">
      </div>
    </template>
    <template v-else>
      <!-- 电脑端创建学术主页的弹窗 -->
      <CreateDialog
        :dialogVisible="pcCreateDialogVisible"
        @closeDialog="pcCreateDialogVisible = false">
      </CreateDialog>
      <!-- 电脑端登陆学术主页的弹窗 -->
      <LoginDialog
        :dialogVisible="pcLoginDialogVisible"
        @closeDialog="pcLoginDialogVisible = false">
      </LoginDialog>
      <!-- 电脑端验证手机号码的弹窗 -->
      <CheckDialog
        :dialogVisible="pcCheckDialogVisible"
        @closeDialog="pcCheckDialogVisible = false">
      </CheckDialog>
      <!-- 跳转学术格子宣传页中间弹框 -->
      <AddDialog
        title="添加成果"
        message="添加学术成果"
        subMessage="您需要使用科研神器「学术格子」管理成果"
        buttonText="立即使用"
        :imgSrc="uploadImg"
        :scholarPcVisible="scholarPcVisible"
        @buttonAction="lingToAcagridPc"
        @closeAcagridDialog="closeAcagridDialog">
      </AddDialog>
      <!-- 点击重要程度排序弹窗 -->
      <AddDialog
        title="什么是重要度"
        message="什么是重要度？"
        subMessage="重要度是系统根据成果的期刊、排名、影响因子、课题类型等因素智能分析的参考值，分值从1-100，级别越高的成果重要度分值越高， 您可前往「学术格子」进行修改。"
        buttonText="立即修改"
        :imgSrc="weightImg"
        :scholarPcVisible="scholarPcWeightVisible"
        @buttonAction="lingToAcagridInfoPc"
        @closeAcagridDialog="scholarPcWeightVisible = false">
      </AddDialog>
    </template>
  </div>
</template>

<script>
import changeThemeColor from '@/mixins/changeThemeColor'
import stopScroll from '@/mixins/stopMaskingScroll'
import Header from '@/components/Header/index'
import Tag from '@/components/Tag/index'
import Social from '../Social/index'
import Interactive from '../Interactive/index'
import MobileLoginDialog from '@/components/MobileLoginDialog'
import CreateDialog from '@/components/CreateDialog'
import { Toast } from 'mint-ui'
import src from '@/assets/pc_edit.png'
import MobileAddDialog from '@/components/MobileAddDialog/index'
import AddDialog from '@/components/AddDialog/index'
import CheckDialog from '@/components/CheckDialog'
import LoginDialog from '@/components/LoginDialog'
import ModifyAvatar from '../ModifyAvatar/index.vue'
import Groups from '../groups'

import uploadImg from '../../../assets/academic_prompt.png'
import weightImg from '../../../assets/academic_weight.png'
import SkeletonIndex from '@/components/skeleton/index'

import ApiMixins from './apiMixins'
import EditInfor from '../EditInfor/index'
import NotPublic from '@/components/NotPublic/index'
import SortModules from '../SortModules/index'
import EmptyModule from '../EmptyModule/index'
import HideModule from '../HideModule/index'
import FooterAd from '@/components/FooterAd'
import ColorPalette from '@/components/ColorPalette'
import HeaderMobile from '@/components/HeaderMobile'
import MobilePopup from '@/components/MobilePopup'
import papers from '../papers'
import projects from '../projects'
import awards from '../awards'
import books from '../books'
import patents from '../patents'
import SideTools from '@/components/SideTool'

export default {
  name: 'Index',
  mixins: [changeThemeColor, stopScroll, ApiMixins],
  data () {
    return {
      loading: true,
      editing: false, // 全局的编辑态
      open: true, // 公开主页
      data: null, // 所有的数据
      dataClone: null, // 所有数据的备份
      profile: null, // 基本资料
      loginUser: null, // 当前登录用户信息
      socialites: null, // 社交资料
      email_hide: 0, // 邮箱是否隐藏
      dialogVisible: false,
      modifyDialogVisible: false,
      sortDialogVisible: false,
      visibleIntro: false,
      visibleEducation: false,
      visibleCareer: false,
      is_first_edit: 0,
      isMobile: false,
      src,
      popupVisible: false,
      title: '用电编辑主页体验更好，更流畅',
      content: '您可以在电脑端编辑，打开浏览器输入网址：https://scholar.acagrid.com/',
      text: '复制网址',
      loadingText: '',
      chatCodeVisible: false,
      pcCreateDialogVisible: false,
      scholarVisible: false,
      scholarPcVisible: false,
      addAcagridTitle: '',
      isShow: false,
      scrollTop: 0,
      likeCount: 0,
      visiteCount: 0,
      pcCheckDialogVisible: false,
      pcLoginDialogVisible: false,
      scholarPcWeightVisible: false,
      uploadImg,
      weightImg,
      scholarWeightVisible: false,
      shareMasking: false,
      silentlyTimer: null,
      // 组件ColorPalette的显示隐藏
      showColorPalette: false,
      // 背景图片img
      backgroundUrl: null,
      backgroundUrlMobile: null,
      // 随机数字1
      num: 1,
      // 传值给子组件
      backgroundUrlRondo: null,
      // 状态
      coverType: null,
      // 已上传的img
      customCoverUrl: null,
      // 正在选中的封面类型
      select_cover_type: null,
      // 随机封面img地址
      randomImgUrl: null,
      // 上传封面img地址
      uploadImgUrl: null,
      // 存放后台给下的cover-image
      coverImageObj: null
    }
  },
  created () {
    this.setDefault()
    this.getUserInfo()
    this.seePersonalData()
    this.academicHomepages()
  },
  mounted () {
    this.addEvent()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', () => {
      this.scrollShow()
    })
    window.clearInterval(this.silentlyTimer)
  },
  methods: {
    addEvent () {
      window.addEventListener('scroll', () => {
        this.scrollShow()
      })
      // 30s 静默保存
      this.silentlyTimer = setInterval(() => {
        if (this.editing) {
          this.saveAcademicHomepages()
        }
      }, 30000)
    },
    scrollShow () {
      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (this.isMobile) {
        if (this.scrollTop > 0) {
          this.isShow = true
        } else {
          this.isShow = false
        }
      }
    },
    /*****
     * 设置default数据
     **/
    setDefault () {
      if (document.body.offsetWidth < 500) {
        this.isMobile = true
      }
      if (this.$route.params.isEditing) {
        this.editing = true
      }
    },
    ColorPaletteShow () {
      // this.showColorPalette = true
    },
    onClickShowColorPalette () {
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      this.showColorPalette = !this.showColorPalette
    },
    ColorPaletteHide (obj, randomImgUrl, uploadImgUrl) {
      if (obj.isNotCover) {
        this.select_cover_type = 0
      } else if (obj.isRandomCover) {
        this.select_cover_type = 1
      } else {
        this.select_cover_type = 2
      }
      this.randomImgUrl = randomImgUrl
      this.uploadImgUrl = uploadImgUrl
    },
    // ColorPalette $emit
    getUrl (url) {
      this.backgroundUrl = url
    },
    modifyRandombackdropUrl (img) {
      var url = `https://img.okay.do/acagrid/static/scholar/static/cover_0${this.num}.png`
      var Mixurl = `https://img.okay.do/acagrid/static/scholar/static/cover_s_0${this.num}.png`
      this.num++
      this.num = this.num === 9 ? 1 : this.num
      this.backgroundUrl = url
      this.backgroundUrlRondo = Mixurl
    },
    NotRandombackdropUrl (img) {
      this.backgroundUrl = img
    },
    modifyRondom (url) {
      this.backgroundUrl = url.replace(/_s_/, '_')
    },
    /**
     * 修改上传img
     */
    modifyUpload (img) {
      this.backgroundUrl = img
    },
    /**
     * 切换游戏显示隐藏模式
     */
    switchHide () {
      this.email_hide = this.email_hide ? 0 : 1
    },
    /**
     * 封装消息提示
     * @param  {string} text [提示的文案]
     */
    notification (text) {
      if (this.isMobile) {
        Toast(text)
      } else {
        this.$message({
          message: text,
          type: 'success'
        })
      }
    },
    /**
     * [entryEditing description]
     * @param  {[Boolean]} flag [是否进入编辑模式]
     * @return null
     */
    entryEditing (flag) {
      if (!this.editing) {
        this.notification('已进入编辑状态，每隔30秒系统将自动保存')
        // 放在editMoreItem之前保证隐藏模块能够拉取全部数据
        this.editing = flag
        // 进入编辑模式获取更多的模块数据，便于编辑
        this.editMoreItem()
      } else {
        this.editing = flag
      }
    },
    entryEditInfor () {
      if (this.isMobile) {
        this.saveAcademicHomepages(() => {
          if (this.editing) {
            this.$router.push({name: 'ProfileMobile', params: {id: this.$route.params.id, isEditing: true}})
          } else {
            this.$router.push({name: 'ProfileMobile', params: {id: this.$route.params.id}})
          }
        })
      } else {
        this.editing = true
        this.dialogVisible = true
      }
    },
    closeDialog () {
      this.dialogVisible = false
    },
    modifyAvatar () {
      this.modifyDialogVisible = true
    },
    closeModifyDialog () {
      this.modifyDialogVisible = false
    },
    avatarOperation (val) {
      this.profile.avatar = val
    },
    update (val) {
      this.socialites = JSON.parse(JSON.stringify(val))
    },
    sortModules () {
      this.sortDialogVisible = true
    },
    updateModules (modulesClone) {
      this.data.modules = modulesClone
      this.sortDialogVisible = false
      this.editMoreItem()
    },
    updateModule (item, index, bool) {
      if (!bool) {
        // 二次确认
        this.$confirm('模块将设为隐藏，将不在主页展示，其他人浏览时不可见。', `确认隐藏「${item.name_cn}」模块吗？`, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$set(this.data.modules[index], 'is_show', 0)
        }).catch(() => {})
      } else {
        this.$set(this.data.modules[index], 'is_show', 1)
        this.editMoreItem(index)
      }
    },
    hideModule (index) {
      this.$set(this.data.modules[index], 'is_show', 0)
      this.visibleIntro = false
      this.visibleEducation = false
      this.visibleCareer = false
    },
    linkTo (type) {
      if (this.isMobile) {
        this.scholarVisible = true
        var element = document.querySelector('.scholar-prompt')
        element.addEventListener('touchmove', function (event) {
          event.preventDefault()
        }, false)
        return false
      }
      this.linkToType = type
      this.addAcagridTitle = '添加成果'
      this.scholarPcVisible = true
    },
    updateItem (index, sub, bool) {
      if (bool) {
        if (this.isMobile) {
          Toast('操作成功，已显示')
        } else {
          this.$message({
            message: '操作成功，已显示',
            type: 'success'
          })
        }
      } else {
        if (this.isMobile) {
          Toast('操作成功，已隐藏')
        } else {
          this.$message({
            message: '操作成功，已隐藏',
            type: 'success'
          })
        }
      }
      this.$set(this.data.modules[index].data[sub], 'display_status', bool)
    },
    updateProfile (profileClone) {
      this.email_hide = profileClone.email_hide
      delete profileClone.email_hide
      this.profile = profileClone
      this.dialogVisible = false
    },
    cancelEditing () {
      try {
        this.profile = this.dataClone.profile
        this.socialites = JSON.parse(this.dataClone.socialites)
        this.data.modules = JSON.parse(JSON.stringify(this.dataClone.modules))
        this.$store.commit('config/changeThemeColor', this.dataClone.color)
        this.toggleClass(document.body, 'custom-' + this.dataClone.color)
        this.$store.commit('config/changeOpenAccess', String(this.dataClone.open_access))
        this.entryEditing(false)
        // 关闭主题设置
        this.showColorPalette = false
      } catch (e) {
      }
    },
    saveEditing () {
      this.saveAcademicHomepages(() => {
        this.showColorPalette = false
        if (this.isMobile) {
          Toast({
            message: '保存成功',
            iconClass: 'iconfont icon--tick-C',
            className: 'toast-save-success'
          })
        } else {
          this.$message({
            message: '保存成功',
            type: 'success'
          })
        }
        this.$route.params.isEditing = false
        this.entryEditing(false)
      }, () => {
        if (this.isMobile) {
          Toast({
            message: '保存失败',
            iconClass: 'iconfont icon--close'
          })
        } else {
          this.$message.error('保存失败')
        }
      })
    },
    pcEdit () {
      this.popupVisible = true
    },
    mobileEditing () {
      Toast({
        message: '已进入编辑状态，每隔30秒系统将自动保存',
        className: 'toast-editing-tips'
      })
      this.editing = true
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
    },
    copyLink () {
      this.$copyText('https://scholar.acagrid.com/').then(function (e) {
        // 提示复制成功
        Toast('已复制到粘贴板')
      }, function (e) {

      })
      this.popupVisible = false
    },
    toVisitorSection () {
      if (document.querySelector('.visitor-section')) {
        let total = document.querySelector('.visitor-section').offsetTop
        this.anchorPosition(total)
      }
    },
    toLikeSection () {
      if (document.querySelector('.like-section')) {
        let total = document.querySelector('.like-section').offsetTop
        this.anchorPosition(total)
      }
      if (!this.open && this.loginUser.liked) {
        if (this.isMobile) {
          Toast('您已经点过赞啦')
        } else {
          this.$message('您已经点过赞啦')
        }
      }
    },
    anchorPosition (total) {
      // 平滑滚动，时长300ms，每10ms一跳，共30跳
      // 获取当前滚动条与窗体顶部的距离
      let distance = document.documentElement.scrollTop || document.body.scrollTop
      // 计算每一小段的距离
      if (distance < total) {
        var smoothDown = function () {
          let step = total / 70
          if (distance < total) {
            distance += step
            // 移动一小段
            document.body.scrollTop = distance
            document.documentElement.scrollTop = distance
            // 设定每一次跳动的时间间隔为10ms
            setTimeout(smoothDown, 3)
          } else {
            // 限制滚动停止时的距离
            document.body.scrollTop = total
            document.documentElement.scrollTop = total
          }
        }
        smoothDown()
      } else if (distance > total) {
        var smoothUp = function () {
          let step = total / 5
          if (distance > total) {
            distance -= step
            // 移动一小段
            document.body.scrollTop = distance
            document.documentElement.scrollTop = distance
            // 设定每一次跳动的时间间隔为10ms
            setTimeout(smoothUp, 6)
          } else {
            // 限制滚动停止时的距离
            document.body.scrollTop = total
            document.documentElement.scrollTop = total
          }
        }
        smoothUp()
      } else {
      }
    },
    createScholar () {
      if (this.loginUser && this.loginUser.homepage_uid > 0) {
        window.location.href = `${window.location.origin}/${this.loginUser.id}`
        return false
      }
      if (this.isMobile) {
        this.stopScroll('.scholar-page-mobile')
        this.chatCodeVisible = true
      } else {
        this.pcCreateDialogVisible = true
      }
    },
    goMyScholar (id) {
      window.location.href = `${window.location.origin}/${id}`
    },
    lingToAcagrid () {
      // 跳转至应用宝
      window.location.href = 'http://sj.qq.com/myapp/detail.htm?apkName=com.quickwis.academe'
    },
    lingToAcagridPc (type) {
      // 链接跳转
      switch (this.linkToType) {
        case 'papers':
          this.scholarPcVisible = false
          window.open('http://www.acagrid.com/doc/factory/post/md/paper.html', '_blank')
          break
        case 'projects':
          this.scholarPcVisible = false
          window.open('http://www.acagrid.com/doc/factory/post/md/govresearch.html', '_blank')
          break
        case 'awards':
          this.scholarPcVisible = false
          window.open('http://www.acagrid.com/doc/factory/post/md/award.html', '_blank')
          break
        case 'patents':
          this.scholarPcVisible = false
          window.open('http://www.acagrid.com/doc/factory/post/md/patent.html', '_blank')
          break
        case 'books':
          this.scholarPcVisible = false
          window.open('http://www.acagrid.com/doc/factory/post/md/book.html', '_blank')
          break
      }
    },
    lingToAcagridInfoPc () {
      window.open('http://www.acagrid.com/doc/factory/info/md/paper#paper', '_blank')
    },
    closeAcagridDialog () {
      this.scholarPcVisible = false
    },
    authorize () {
      var appid = process.env.APP_ID
      var url = encodeURI(`${window.location.origin}/${this.$route.params.id}`)
      // var url = encodeURI(`${window.location.origin}/bind_mobile`)
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=342bb17b4a7ff6f636e3db5f4cee1e6a#wechat_redirect`
    },
    loginScholar () {
      this.pcLoginDialogVisible = true
    },
    quickSort (type, module, key, order, normalize) {
      let index = this.data.modules.findIndex((item) => {
        return item.name === type
      })
      this.$set(this.data.modules[index], 'sort_type', order)
      this.data.modules[index].data.sort((a, b) => {
        if (order === 'time:asc') {
          return normalize(a[module][key]) - normalize(b[module][key])
        } else if (order === 'time:desc' || order === 'weight:desc') {
          return normalize(b[module][key]) - normalize(a[module][key])
        }
      })
      if (order === 'time:asc') {
        this.notification('已按获得时间升序排列')
      } else if (order === 'time:desc') {
        this.notification('已按获得时间降序排列')
      } else if (order === 'weight:desc') {
        this.notification('已按重要程度降序排列')
      }
      setTimeout(() => {
        if (order === 'weight:desc') {
          if (this.isMobile) {
            this.scholarWeightVisible = true
            this.stopScroll('.scholar-prompt-weight')
          } else {
            this.scholarPcWeightVisible = true
          }
        }
      }, 1000)
    },
    handleCommand (command) {
      if (command.name === 'sortModule') {
        this.sortModules()
      } else if (command.name === 'hideModule') {
        this.hideModule(command.index)
      }
    },
    shareMaskingShow () {
      this.shareMasking = true
      this.$nextTick(function () {
        this.stopScroll('.share-masking')
      })
    },
    noPointerEvents (className) {
      var element = document.querySelector(className)
      console.log(element)
      element.addEventListener('click', function (evt) {
        this.style.display = 'none'
        var x = evt.pageX
        var y = evt.pageY
        var under = document.elementFromPoint(x, y)
        this.style.display = ''
        evt.stopPropagation()
        evt.preventDefault()
        document.querySelector(under).trigger(evt.type)
      }, false)
    },
    replaceWrap (value) {
      return value.replace(/\n/g, '<br/>')
    }
  },
  computed: {
    themeColor: function () {
      return this.$store.state.config.themeColor
    },
    openAccess: function () {
      return this.$store.state.config.openAccess
    },
    acagridOrigin () {
      return process.env.WEB_ORIGIN
    }
  },
  components: {
    Header,
    Social,
    EditInfor,
    ModifyAvatar,
    Tag,
    papers,
    projects,
    awards,
    books,
    patents,
    NotPublic,
    SortModules,
    EmptyModule,
    HideModule,
    FooterAd,
    ColorPalette,
    HeaderMobile,
    MobilePopup,
    Interactive,
    MobileLoginDialog,
    CreateDialog,
    MobileAddDialog,
    AddDialog,
    CheckDialog,
    LoginDialog,
    SkeletonIndex,
    Groups,
    SideTools
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import './index.scss';
</style>
<style lang="scss">
  .basic-info,
  .section-wrap {
    .is-plain {
      background-color: transparent;
    }
  }
  .basic-info {
    margin: 68px auto 48px;
    position: relative;
    .name {
      font-size: 4rem;
      small {
        font-size: 2rem;
        margin-left: 25px;
      }
    }
    .school-info {
      line-height: 28px;
    }
  }
  .section-wrap {
    margin: 50px 20px 50px 40px;
    section {
      .head {
        border-bottom: 1px solid #DCDFE6;
        padding-bottom: 10px;
        font-weight: bold;
        margin-bottom: 12px;
        line-height: 36px;
        .iconfont {
          margin-right: 5px;
          font-size: 20px;
          font-weight: normal;
          vertical-align: sub;
        }
        .operation {
          color: #000;
          font-size: 0;
          .el-dropdown {
            cursor: pointer;
          }
          .el-dropdown:nth-child(2) {
            margin: 0 20px 0 30px;
          }
          > span {
            font-weight: normal;
            cursor: pointer;
            font-size: 14px;
            margin-left: 20px;
          }
          a {
            font-size: 14px;
            color: var(--color-main);
          }
        }
      }
      .detail {
        margin-bottom: 50px;
        .el-textarea__inner {
          line-height: 28px;
        }
        li {
          line-height: 28px;
          margin-bottom: 15px;
          position: relative;
          .status {
            position: absolute;
            top: 0;
            cursor: pointer;
          }
          .status-show {
            left: -25px;
            i {
              font-size: 25px;
            }
            .absolute {
              position: absolute;
              left: 0;
              top: 0;
              opacity: 0;
              z-index: -1;
            }
          }
          .status-hide {
            font-size: 12px;
            left: -64px;
            color: rgba(0,0,0,.25);
            .iconfont {
              vertical-align: middle;
              margin-left: 4px;
            }
            i {
              font-size: 25px;
            }
          }
          &.status-hide {
            color: rgba(0,0,0,.25);
          }
        }
      }
      .show-more,
      .hide-more {
        .iconfont {
          vertical-align: middle;
          margin-left: 4px;
          font-size: 12px;
        }
      }
      .hide-module .head {
        > span {
          opacity: .5
        }
        .iconfont {
          color: #303133;
        }
      }
    }
  }
  @media screen and (max-width: 500px) {
    #app .content section {
      padding-left: 0px;
    }

    #app .section-wrap {
      margin: 0;
      background-color: #f5f5f5;
      section {
        background-color: #fff;
        margin-bottom: 15px;
        .head {
          margin: 20px;
          padding-top: 30px;
          .operation {
            .el-dropdown:nth-child(2) {
              margin: 0 0 0 10px;
            }
          }
        }
        .detail {
          margin: 20px;
          padding-bottom: 20px;
          li {
            &.status-hide {
              span:first-child {
                font-size: 0;
                left: -37px;
              }
            }
            .status-show {
              left: -35px;
            }
            .icon--show,.icon--hide {
              font-size: 34px;
              vertical-align: middle;
              margin-left: 4px;
            }
            span {
              word-wrap: break-word;
            }
          }
          .text {
          }
        }
        .research-papers,
        .honor-award,
        .books,
        .patent,
        .support-project {
          .detail {
            padding-left: 20px;
          }
        }
      }
    }
    .el-message-box {
      width: 90% !important;
    }
  }
  .mint-toast.homepage-created-success {
    padding: 30px 18px !important;
  }
  .mint-toast.toast-save-success {
    width: 124px;
  }
  #app .content .v-modal {
    opacity: 0.7;
  }
  #research-direction .is_backgroundUrl{
    color: rgb(255, 255, 255);
    background: rgba(255,255,255,0.2);
    border-color: #fff;

  }
</style>



// WEBPACK FOOTER //
// src/pages/Index/Index/index.vue